import { render } from "./editGradients.vue?vue&type=template&id=90f9c3de&scoped=true&ts=true"
import script from "./editGradients.vue?vue&type=script&lang=ts"
export * from "./editGradients.vue?vue&type=script&lang=ts"

import "./editGradients.vue?vue&type=style&index=0&id=90f9c3de&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90f9c3de"]])

export default __exports__